<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="业务员信息：" prop="nameOrPho">
            <el-input v-model="query.nameOrPho" placeholder="请输入姓名/手机号" size="small" />
          </el-form-item>
          <el-form-item label="身份：">
            <el-select v-model="query.levelId" placeholder="请选择" clearable size="small" @change="handleTechnical">
              <el-option v-for="item in options.businessStanding" :key="item.id" :label="item.name" :value="item.level"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="管辖区域：">
            <el-cascader :props="cascaderProps" v-model="query.customerAreaAddrid" collapse-tags :show-all-levels="false" :options="regionOptions" clearable size="small"></el-cascader>
          </el-form-item>
          <el-form-item label="上级手机号：">
            <el-input v-model="query.parentNameOrPho" placeholder="请输入上级手机号" size="small" />
          </el-form-item>
          <el-form-item label="权益状态：">
            <el-select v-model="query.state" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="已授权" :value="1"></el-option>
              <el-option label="未授权" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="query.timeType" placeholder="请选择" clearable size="small">
              <el-option label="加入时间" :value="1"></el-option>
              <el-option label="修改时间" :value="2"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="doQueryList({pageNo:1})">
          <el-tab-pane label="在职" name="0"></el-tab-pane>
          <el-tab-pane label="离职" name="1"></el-tab-pane>
          <el-tab-pane label="离职交接中" name="2"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleDownload" plain v-hasPermi="['business:businessList:export']">导出</el-button>
          <!-- <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(row,2)">调整上级</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,1)">设为在职</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <!-- <el-button type="primary" size="mini" @click="handleBatch" v-if="activeName=='1'">批量设为在职</el-button> -->
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus" v-hasPermi="['business:businessList:add']">添加业务员</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" style="width: 100%;" :key="activeName">
        <el-table-column type="selection" width="50" />
        <el-table-column label="基础信息" prop="name" align="center" width="160" fixed>
          <template slot-scope="{row}">
            <div>业务员id: {{ row.customer.id }}</div>
           <div>用户id：{{ row.customer.userId }}</div>
          </template>
        </el-table-column>
        <el-table-column label="业务员信息" prop="" align="center" width="120">
          <template slot-scope="{row}">
            <div @click="handleShow(row)">
              <el-link type="primary">{{row.customer.name}}</el-link><br />
              <el-link type="primary">{{row.customer.pho}}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="activeName==0?'身份':'离职前身份'" prop="" align="center" width="110">
          <template slot-scope="{row}">
            {{row.customerLevel.name}}
          </template>
        </el-table-column>
        <el-table-column label="上级信息" prop="" align="center" width="120" v-if="activeName==0">
          <template slot-scope="{row}">
            <div>
              <span type="primary" v-if="row.line && row.lineLevel">{{row.line.name}}({{row.lineLevel.name}})</span><br />
              <span type="primary" v-if="row.line">{{row.line.pho}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="所在区域" prop="areaCount" align="center" v-if="activeName!=2" width="130">
          <template slot-scope="{row}" v-if="row.addr && row.addr.length">
            {{row.addr[0].regionName}}{{row.addr[1].regionName}}{{row.addr.length==3?row.addr[2].regionName:''}}
          </template>
        </el-table-column>
        <el-table-column label="城市公司" prop="cityCompany.name" align="center" width="200" />
        <el-table-column label="管辖区域数量" prop="" align="center" v-if="activeName==0" width="130">
          <template slot-scope="{row}">
            <el-link type="primary" @click="showArea(row.customer,row.areaCount)">{{row.areaCount}}</el-link><br />
          </template>
        </el-table-column>
        <el-table-column label="下级团队人数" prop="childCount" align="center" sortable v-if="activeName==0" width="130">
          <template slot-scope="{row}">
            {{row.childCount}}
          </template>
        </el-table-column>
        <el-table-column label="加入时间" prop="customer.createdTime" align="center" sortable width="160" v-if="activeName==0">
          <template slot-scope="{row}">
            {{dayjs(row.customer.createdTime).format("YYYY-MM-DD HH:mm:ss")}}
          </template>
        </el-table-column>

        <el-table-column label="权益状态" prop="state" align="center" width="200" v-if="activeName==0">
          <template slot-scope="{row}">
            <el-switch v-model="row.customer.state" active-text="已授权" inactive-text="未授权" :active-value="1" :inactive-value="0" @change="handleState(row)">
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column label="修改时间" prop="customer.operatedTime" align="center" sortable width="160" v-if="activeName==0">
          <template slot-scope="{row}">
            {{dayjs(row.customer.operatedTime).format("YYYY-MM-DD HH:mm:ss")}}
          </template>
        </el-table-column>
        <el-table-column label="离职时间" prop="customer.operatedTime" align="center" sortable width="160" v-if="activeName!=0">
          <template slot-scope="{row}">
            {{dayjs(row.customer.departedTime).format("YYYY-MM-DD HH:mm:ss")}}
          </template>
        </el-table-column>
        <el-table-column label="操作人" prop="operated_by" align="center" />
        <el-table-column label="操作" align="center" width="250" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row,1)" v-if="activeName=='0'" v-hasPermi="['business:businessList:edit']">编辑</el-button>
            <el-button type="text" @click="handleUpdate(row,2)" v-if="activeName=='0'" v-hasPermi="['business:businessList:identity']">修改身份</el-button>
            <el-button type="text" @click="handleUpdate(row,0)" v-if="activeName=='0'" v-hasPermi="['business:businessList:setas']">设为离职</el-button>
            <el-button type="text" @click="handleUpdate(row,6)" v-if="activeName=='1'" v-hasPermi="['business:businessList:setas']">设为在职</el-button>
            <el-button type="text" @click="handleUpdate(row,-1)" v-if="activeName=='1'">日志记录</el-button>
            <el-button type="text" v-if="activeName=='2'">离职交接中</el-button>
            <el-dropdown @command="handleCommand" v-if="activeName=='0'">
              <el-button type="text">更多<i class="el-icon--right el-icon-arrow-down"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="beforeHandleCommand(row,5)" v-hasPermi="['business:businessList:area']">添加区域</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,0)" v-if="row.areaCount" v-hasPermi="['business:businessList:delarea']">移除区域</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,3)" v-if="row.childCount" v-hasPermi="['business:businessList:team']">团队调整</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,7)" v-if="row.childCustomerCount" v-hasPermi="['business:businessList:customer']">客户调整</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,4)" v-if="row.customer.clevel!=1" v-hasPermi="['business:businessList:superiors']">调整上级</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,8)" v-if="row.customer.clevel==3" v-hasPermi="['business:businessList:ratio']">分润比例</el-dropdown-item>
                <!-- <el-dropdown-item :command="beforeHandleCommand(row,'')">调整部门</el-dropdown-item> -->
                <el-dropdown-item :command="beforeHandleCommand(row,9)" v-if="row.customer.clevel==3" v-hasPermi="['business:businessList:time']">观察时间</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,21)" v-if="row.customerUserPO.entryInhibited">{{row.customerUserPO.entryInhibited?'恢复登录':'禁止登录'}}</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,20)">调整城市公司</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,22)">清除缓存</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,24)" v-if="row.customer.clevel==3">大区入职时间</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,23)" v-if="row.customer.clevel==3">继承/开发客户</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,10)">日志记录</el-dropdown-item>

              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <el-dialog title="管辖区域" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
      <div class="dialog-box">
        <el-tree :data="areaOptions" :props="defaultProps"></el-tree>
      </div>
    </el-dialog>
    <el-dialog title="设置大区入职时间" :visible.sync="isareatimeDialogVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="isareatimeForm" label-width="100px">
        <el-form-item label="入职时间">
          <el-date-picker v-model="isareatimeForm.isareatime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择时间" size="small" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isareatimeDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="submitIsAreaTime">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 新建表单 -->
    <business-add ref="businessAdd" @created="handleAddCallback" :businessStanding="options.businessStanding" :addressLists="regionOptions" :configList="configList" :popType="popType" />
    <business-quit ref="businessQuit" @created="doQueryList({})" />
    <business-adjust ref="businessAdjust" @created="doQueryList({})" :popType="popType" />
    <area-remove ref="areaRemove" @created="doQueryList({})" />
    <city-company-vue ref="cityCompanyVue" @created="cityCompanySubmit" />
  </div>
</template>

<script>
import businessAdd from './add'
import businessQuit from './quit'
import businessAdjust from './adjust'
import areaRemove from './areaRemove'
import clientListApi from '@/api/client/clientList'
import clientAreaApi from '@/api/client/clientArea'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import customerLevelApi from '@/api/sys/customerLevel'
// import sysProfitRatioApi from '@/api/sys/sysProfitRatio'
import sysAddrApi from '@/api/sys/sysAddr'
// import clientLabelApi from '@/api/client/label'
// import technicianInfoApi from '@/api/technical/technicianInfo'
import Pagination from '@/components/Pagination'
import cityCompanyVue from '@/views/client/clientList/cityCompany.vue'
import userApi from '@/api/sys/user'
import customerApi from '@/api/technical/customer'
export default {
  components: {
    Pagination,
    businessAdd,
    businessQuit,
    businessAdjust,
    areaRemove,
    cityCompanyVue
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      formVisible: false,
      query: {
        pageNo: 1,
        pageSize: 10,
        customerType: 2
      },
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
        checkStrictly: true
      },
      selectItems: [],
      activeName: '0',
      standingList: [],
      discountList: [],
      configList: [],
      labelList: [],
      technicianList: [],
      options: {
        businessStanding: [],
        identityOptions: []
      },
      areaOptions: [],
      popType: 0,
      addressList: [],
      regionOptions: [],
      dateTime: null,
      defaultProps: {
        children: 'child',
        label: 'areaName'
      },
      isareatimeDialogVisible: false,
      isareatimeForm: {
        id: null,
        isareatime: ''
      },
    }
  },
  created() {
    this.doQueryList({
      pageNo: 1
    })
    this.getBusinessStanding()
    this.getConfig()
    // this.getLabelList()
    this.getAddressList()
    // this.getTechnicianList()
  },
  methods: {
    cityCompanySubmit(type, row) {
      if (type) {
        this.popType = 1
        this.$refs.businessAdd.handleUpdate({
          'row': row,
          'command': 1
        })
      }
      this.doQueryList({})
    },
    handleAddCallback(row) {
      if (row) {
        this.$refs.cityCompanyVue.handleUpdate(row)
      }
      this.doQueryList({})
    },
    handleDownload() {
      this.$router.push("/export/list?code=CustomerDownloadExcelDiy2")
    },
    // 获取区域列表
    getAddressList() {
      sysAddrApi.getAddressTreeList().then(({ data }) => {
        this.regionOptions = this.formatCascaderData(data)
        // console.log('地区列表: ',data);
      })
    },
    showArea(customer, num) {
      if (!num) return
      this.changeIdentity(customer)
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        customerType: 2
      }
      this.dateTime = []
      this.doQueryList({
        pageNo: 1
      })
    },
    // 权益状态修改
    async handleState(row) {
      console.log('row: ', row);
      // return
      await clientListApi.updateAccount([{
        id: row.customer.id,
        // isOpenSea: 0,
        state: row.customer.state ? 1 : 0
      }])
      this.$message.success('提交成功！您的任务已开始执行，请耐心等待。您可以前往任务表查看进度')
      // this.doQueryList({ pageNo: this.query.pageNo })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    // 获取区域列表
    changeIdentity(customer) {
      let obj = {}
      obj.customerId = customer.id
      obj.parentCustomerId = customer.parentId
      obj.addOrDelete = 2
      obj.v = 3
      this.loading = this.$loading({
        lock: true,
        text: "加载中",
        background: "rgba(0, 0, 0, 0.7)",
      });
      clientAreaApi.fetchTreeList(obj).then(({ data }) => {
        this.loading.close()
        if (data) {
          this.areaOptions = data
          this.formVisible = true
        }
      }).catch(() => {
        this.loading.close()
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    /**
     * 分类筛选
     */
    handleClick() {
      this.doQueryList({
        pageNo: 1
      })
      // console.log("activeName: ",this.activeName);
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    doQueryList({
      pageNo,
      pageSize
    }) {
      this.query.isDeparted = this.activeName * 1
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = {
        ...this.query
      }
      if (this.query.customerAreaAddrid) {
        query.customerAreaAddrid = this.query.customerAreaAddrid[this.query.customerAreaAddrid.length - 1]
      }
      if (this.query.timeType && this.dateTime && this.dateTime.length) {
        query.startTime = this.dateTime[0]
        query.endTime = this.dateTime[1]
      }
      if (this.dateTime && this.dateTime.length && !this.query.timeType) {
        this.dateTime = null
      }
      // this.query.displayPosition=this.activeName
      this.listLoading = true
      return clientListApi.fetchList(query)
        .then(({
          data
        }) => {
          console.log("data: ", data);
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    // 获取业务员身份
    getBusinessStanding() {
      customerLevelApi.fetchList({
        type: 2
      }).then(({
        data
      }) => {
        this.options.businessStanding = data
        console.log('客户身份: ', data);
      })
    },
    // 获取系统配置
    getConfig() {
      sysDataconstantApi.fetchBatchCode({
        code: 'profitSharingRatioForL7,profitSharingRatioForL6'
      }).then(({
        data
      }) => {
        this.configList = data.list
        // console.log("配置: ", data);
      })
    },
    // 获取折扣组列表
    getDiscountList() {
      sysProfitRatioApi.fetchList().then(({
        data
      }) => {
        this.discountList = data
        // console.log('折扣组列表: ',data);
      })
    },

    // 获取标签列表
    getLabelList() {
      clientLabelApi.options().then(({
        data
      }) => {
        this.labelList = data
       
      })
    },
    // 获取技术老师列表
    getTechnicianList() {
      technicianInfoApi.listForMini({
        // isGetAllParent: true
      }).then(({
        data
      }) => {
        this.technicianList = data
        console.log('技术老师列表: ', data);
      })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      this.popType = command.command
      //离职
      if (command.command === 1) {
        this.$refs.businessQuit.handleQuit(command.row)
      } else if ([2, 5, 4, 8, 9].includes(command.command)) {

        this.$refs.businessAdd.handleUpdate(command)
        // this.handleBatchState(ids, 2)
      } else if ([3, 7].includes(command.command)) {
        this.$refs.businessAdjust.handleUpdate(command)
      } else if (command.command == 0) {
        console.log('command.row------------: ', command.row);
        this.$refs.areaRemove.handleUpdate(command.row.customer)
      } else if (command.command == 10) {
        this.$router.push("/log/log?type=2&id=" + command.row.customer.id);
      } else if ([20].includes(command.command)) {
        this.$refs.cityCompanyVue.handleUpdate(command.row)
      } else if ([21].includes(command.command)) {
        this.handleEntryInhibited(command.row)
      } else if ([22].includes(command.command)) {
        this.handleClearCache(command.row)
      }else if ([23].includes(command.command)) {
        this.$emit('handleShow', command.row.customer.id, 3,command.row.customer.ywId)
      }else if ([24].includes(command.command)) {
        this.openIsAreaTime(command.row)
      }
    },
    openIsAreaTime(row){
      this.isareatimeForm.id = row.customer.id
      this.isareatimeForm.isareatime = ''
      this.isareatimeDialogVisible = true
    },
    async submitIsAreaTime(){
      if(!this.isareatimeForm.isareatime){
        this.$common && this.$common.showMsg ? this.$common.showMsg('warning','请选择入职时间') : this.$message.warning('请选择入职时间')
        return
      }
      await customerApi.updateisareatime({
        id: this.isareatimeForm.id,
        isareatime: this.isareatimeForm.isareatime
      })
      this.$common && this.$common.showMsg ? this.$common.showMsg('success','保存成功') : this.$message.success('保存成功')
      this.isareatimeDialogVisible = false
      this.doQueryList({})
    },
    handleClearCache(row) {
      this.$common.confirm('是否确认清除缓存')
        .then(() => userApi.delCache({ userId: row.customerUserPO.id }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    handleEntryInhibited(row) {
      this.$common.confirm(row.customerUserPO.entryInhibited ? '是否确认恢复登录' : '是否确认禁止用户登录，禁用了客户不能登录app').then(
        async () => {
          await userApi.updateEntryInhibited({
            entryInhibited: row.customerUserPO.entryInhibited == 1 ? 0 : 1,
            id: row.customerUserPO.id
          })
        }).then(() => {
          this.$common.showMsg('success', `${row.customerUserPO.entryInhibited ? '恢复' : '禁止'}成功`)
          this.doQueryList({ pageNo: 1 })
        })
    },
    handleBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择业务员')
        return
      }
      this.popType = 10
      this.$refs.businessAdd.handleUpdate({
        row: this.selectItems,
        command: 10
      })
    },
    // changeSwitch(row) {
    //   sysBannerApi.setIsEnableExpress({ id: row.id, isEnable: row.isEnable }).then(() => {
    //     this.$common.showMsg('success', '操作成功')
    //   })
    // },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.popType = 0
      this.$refs.businessAdd.handleCreate()
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row.customer.id, 2)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row, type) {
      // console.log('rew',row)
      // return
      if(type === -1) return this.$router.push("/log/log?type=2&id=" + row.customer.id);
      if (type > 0) {
        this.popType = type
        if (type == 6 && row.customer.clevel == 1) {
          this.$common.confirm('是否确认设为在职')
            .then(() => {
              let obj = {
                customerid: row.customer.id,
                isDeparted: 0,
                dataCompareLogType2: 20
              }
              clientListApi.setEntry([obj]).then((data) => {
                this.doQueryList({})
              });
            })
        } else {
          this.$refs.businessAdd.handleUpdate({
            row,
            command: type
          })
        }

      } else {
        if (!row.areaCount && !row.childCount && !row.childCustomerCount) {
          let params = {
            isDeparted: 1,
            connectArea: [],
            connectCustomer: [],
            connectTeam: [],
            customerid: row.customer.id,
            toParentCustomerid: row.customer.parentId,
            dataCompareLogType2: 26
          }
          this.$common.confirm('是否确认提交离职，离职后该业务员无法享受业务权益').then(() => clientListApi.resignQuit([params]))
            .then(() => {
              this.doQueryList({})
            })
        } else {
          this.$refs.businessQuit.handleQuit(row)
        }
      }

    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-box {
  max-height: 70vh;
  overflow-y: auto;
}
::v-deep .el-date-editor{
  width: 100%;
}
</style>
